// extracted by mini-css-extract-plugin
module.exports = {"container":"error-page_container__2bw5v","textContainer":"error-page_textContainer__2Soyo","redirectContainer":"error-page_redirectContainer__2JSQw"};